<template>
  <div class="about spacer">
    <vue-headful
        title="About Us | Who We Are"
        description="At Fedsight, we are a team of management consultants, solution developers, and functional experts all dedicated to creating lasting value. We work differently by thinking holistically and using our experience and insight gained through commercial and federal projects."
        url="https://www.fedsight.com/aboutUs"
    />
        <section class='container-fluid aboutUsHero d-flex align-items-center justify-content-center'>
            <p class='slogan internalHeader'>Who We Are</p>
        </section>

        <section class='mainParagraph'>
            <div class='container'>
                <h1 class='fedsightGreen'>We Assess Problems and Tailor Solutions for Federal Agencies</h1>
                <p>We are a team of management consultants, solution developers, and functional experts all dedicated to creating lasting value. We work differently by thinking holistically and using our experience and insight gained through commercial and federal projects.</p>
            </div>
        </section>

        <section>
          <div class='container m-auto'>
            <div class='row'>
              <div class='col-md-6 backgroundSettings imageDiv1 aboutSquare order-1 order-md-1'>
              </div>
              <div class='col-md-6 aboutSquare fedsightBlueBackground d-flex align-content-center order-2 order-md-2'>
                <div class='contentContainer text-align-left'>
                  <h3 class='fedsightYellow'>Expertise</h3>
                  <p class='aboutText whiteText'>Fedsight has expertise in business functions across the spectrum and is ready to support your organization. Our proven experience in rapidly responding to complex problems means we can help your organization thrive no matter the challenge.</p>
                </div>
              </div>
              <div class='col-md-6 aboutSquare fedsightBlueBackground d-flex align-content-center order-4 order-md-3'>
                <div class='contentContainer text-align-left'>
                  <h3 class='fedsightYellow'>Team</h3>
                  <p class='aboutText whiteText'>Fedsight has a team of exceptional professionals who are committed to enhancing your operational effectiveness. We recruit, develop, and retain the best talent by fostering continuous growth and learning. By solving your problems today, we adaptively plan for the challenges ahead.</p>
                </div>
              </div>
              <div class='col-md-6 backgroundSettings imageDiv2 aboutSquare order-3 order-md-4'>
              </div>
              <div class='col-md-6 backgroundSettings imageDiv3 aboutSquare order-5 order-md-5'>
              </div>
              <div class='col-md-6 aboutSquare fedsightBlueBackground d-flex align-content-center order-6 order-md-6'>
                <div class='contentContainer text-align-left'>
                  <h3 class='fedsightYellow'>Versatility</h3>
                  <p class='aboutText whiteText'>Whether it's management consulting or data analytics, we help organizations gain insight into specific areas by operating across the entire project lifecycle. Everything Fedsight does is performed with a commitment to deliver comprehensive and enduring solutions.</p>
                </div>
              </div>
            </div>
          </div>
        </section>

        <Footer />
  </div>
</template>

<script>
import Footer from '@/components/Footer.vue'
import closeMenu from '../mixins/closeMenu'


export default {
    name: 'aboutUs',
    components: {
        Footer
    },
    metaInfo: {
      link: [
        {rel:'canonical', href:'https://www.fedsight.com/aboutUs'}
      ]
    },
    mixins: [closeMenu],
    mounted() {
        document.dispatchEvent(new Event('page.rendered'));
    }
}

</script>

<style scoped>
.aboutUsHero{
    height: 30rem;
    background-image: url(../assets/about-hero-large.jpg);
    background-position: center;
    background-repeat: no-repeat;
    background-size: cover;
}
.aboutUsHeader{
    color: #fff;
    font-size: 6rem;
}
.mainParagraph{
    padding: 8rem 1.5rem;
    max-width: 80rem;
    margin: auto;
}
.aboutSquare{
  height: 40rem;
}
.contentContainer{
  width: 70%;
  margin: auto;
}
.aboutHeader{
    font-size: 3rem;
    margin: 0rem;
}
.text-align-left{
    text-align: left;
}
.imageDiv1{
  background-image: url('../assets/bigstock-Successful-business-people-dis-287596642.jpg');
}
.imageDiv2{
  background-image: url('../assets/bigstock-Business-Team-On-A-Morning-Bri-240972481.jpg');
}
.imageDiv3{
  background-image: url('../assets/bigstock-Lincoln-Memorial-77108864.jpg');
}
.backgroundSettings{
  background-size: cover;
  background-position: center;
  background-repeat: no-repeat;
}



/* Small devices (landscape phones, 576px and up) */
  @media (max-width: 576px) { 
    .slogan {
      font-size: 3.5rem !important;
    }
    .aboutUsHero{
      background-image: url(../assets/about-hero-small.jpg);
    }
  }

  @media (min-width: 576px) { 
    .aboutUsHero{
      background-image: url(../assets/about-hero-small.jpg);
    }
  }

  @media (max-width: 768px) { 
    .slogan{
      text-align: center;
      margin-left: auto;
      margin-right: auto;
    }
    .aboutUsHero{
      justify-content: center !important;
      background-position: left bottom;
    }
  }

  /* Medium devices (tablets, 768px and up) */
  @media (min-width: 768px) { 
    .aboutUsHero{
      background-image: url(../assets/about-hero-medium.jpg);
    }
  }

  @media (max-width: 992px){
    .container{
        padding: 1.5rem !important;
    }
  }

  /* Large devices (desktops, 992px and up) */
  @media (min-width: 992px) { 
    .aboutUsHero{
      background-image: url(../assets/about-hero-large.jpg);
    }
  }

  /* Extra large devices (large desktops, 1200px and up) */
  @media (min-width: 1200px) { 
    
    .slogan {
      font-size: 9rem !important;
    }
  }
</style>